import React from 'react';
import { Classes } from '@blueprintjs/core';

import Text, { TextProps } from './Text';

const Label = (props: TextProps) => <Text className={Classes.LABEL} {...props} />;

export default Label;
